export interface MillOffer {
	id: string;
	name: string;
	deliveryWeek: number;
	deliveryYear: number;
	idd?: string;
	iddDescription?: string;
	millSite?: string;
	millSiteDescription: string;
	category: string;
	categoryDescription: string;
	subCategory: string;
	subCategoryDescription: string;
	form: string;
	formDescription: string;
	templateNumber?: number;
	metalStud?: boolean;
}

export interface MillOfferResponse {
	key: string;
	millOffers: {
		group: string;
		millOffer: MillOffer;
	}[];
}

export type FieldOfMillOffer = keyof MillOffer;

export function createDefaultMillOffer() {
	return {
		header: {}
	};
}
